import { Link } from "react-router-dom";
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { isInternalPath } from "@/lib/internalLink";

type AppLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  children: ReactNode;
};

export function AppLink({ href, children, className, onClick, target, rel, ...rest }: AppLinkProps) {
  if (isInternalPath(href)) {
    return (
      <Link to={href} className={className} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={className} onClick={onClick} target={target} rel={rel} {...rest}>
      {children}
    </a>
  );
}
